module.exports = __webpack_public_path__ + "static/media/police_logo.d0289dc0.png";